module.exports = __webpack_public_path__ + "img/slack-features.e91629f3.jpeg";